import { ArrowLeftOutlined } from '@ant-design/icons'
import { Col, Row } from 'antd'
import { withFormik } from 'formik'
import moment from 'moment'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Button from '../../../../Components/Button'
import Field from '../../../../Components/Formik/Field'
import Form from '../../../../Components/Formik/Form'
import Panel from '../../../../Layout/Panel'
import PanelLayout from '../../../../Layout/PanelLayout'
import apiClient from '../../../../Util/apiClient'
import { TERMS_CONDITIONS_DOCUMENT_TYPES } from '../../../../Util/Options'
import { termsConditionSchema } from '../../../../Util/validationSchema'

function TermsConditionForm({
  values,
  setValues,
  match: {
    params: { id }
  }
}) {
  const getData = () => {
    if (id) {
      apiClient.get(`terms-conditions/${id}`).then(({ status, data }) => {
        if (status === 200) {
          setValues({ ...values, ...data })
        }
      })
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <Form>
      <Row justify="center" className="inner-contents">
        <Col xs={22} sm={22} md={20} lg={20}>
          <PanelLayout title="Terms Condition Definition">
            <Panel title="Terms Condition">
              <Row gutter={[20, 10]}>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <div className="form-field">
                    <Field
                      as="select"
                      name="type"
                      label="Document Type"
                      options={TERMS_CONDITIONS_DOCUMENT_TYPES}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <div className="form-field">
                    <Field
                      as="date"
                      name="validFrom"
                      label="Valid From"
                      disabledDate={(current) => moment(current).isAfter(values.validTo)}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <div className="form-field">
                    <Field
                      as="date"
                      name="validTo"
                      label="Valid To"
                      disabledDate={(current) => moment(current).isBefore(values.validFrom)}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <div className="form-field">
                    <Field as="rich-text" name="content" label="Full Text" />
                  </div>
                </Col>
              </Row>
            </Panel>
          </PanelLayout>
          <div className="save-changes">
            <Button type="submit" variant="primary">
              {id ? 'Update' : 'Save'}
            </Button>
            <span>or</span>
            <Link to="/app/terms-conditions">
              <Button>
                <ArrowLeftOutlined /> Back to terms conditions
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
    </Form>
  )
}

export default withFormik({
  mapPropsToValues: () => ({
    type: '',
    content: '',
    validFrom: '',
    validTo: ''
  }),
  validationSchema: termsConditionSchema,
  handleSubmit: (
    data,
    {
      props: {
        match: {
          params: { id }
        },
        history
      }
    }
  ) => {
    if (id) {
      apiClient.put(`terms-conditions/${id}`, data).then(({ status }) => {
        if (status === 200) {
          history.push('/app/terms-conditions')
        }
      })
    } else {
      apiClient.post('terms-conditions', data).then(({ status }) => {
        if (status === 201) {
          history.push('/app/terms-conditions')
        }
      })
    }
  }
})(TermsConditionForm)
